



































import Vue from 'vue'
export default Vue.extend({
    props: {
        //  The links being displayed
        links: {
            type: Array,
            required: true
        }
    }
})
